let lockCount = 0;
let previousOverflow = '';

/**
 * Stops the page behind a modal from scrolling. Reference-counted, so two
 * overlapping modals (one opening while the other is still closing) keep the
 * lock until the last one releases it. Returns the release function.
 */
export const lockBodyScroll = () => {
	if (typeof document === 'undefined') {
		return () => {};
	}

	if (lockCount === 0) {
		previousOverflow = document.body.style.overflow;
		document.body.style.overflow = 'hidden';
	}

	lockCount += 1;

	let released = false;

	return () => {
		if (released) {
			return;
		}

		released = true;
		lockCount -= 1;

		if (lockCount === 0) {
			document.body.style.overflow = previousOverflow;
		}
	};
};
